/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react/macro";

import { Link, useNavigate } from "react-router-dom";
import {
  INITIAL_CATEGORY_ENTITY,
  useForeCategoryEntityQuery,
  useFunctionsQuery,
} from "services/api";
import IconEye from "images/icon-eye.svg";
import IconEdit from "images/icon_edit.svg";

type Props = {
  categoryId: number;
  dataSource: string;
  id: number;
  name: string;
  thumbnailUrl: string;
  url: string;
  viewsCount: number;
};

const Card = ({
  categoryId,
  dataSource,
  id,
  name,
  thumbnailUrl,
  url,
  viewsCount,
}: Props) => {
  const { data: categoryEntity = INITIAL_CATEGORY_ENTITY } =
    useForeCategoryEntityQuery();

  // 前端圖表增加 edit 按鈕 => 如果 isEditable 為 true 則顯示編輯按鈕
  const { isEditable } = useFunctionsQuery(undefined, {
    selectFromResult: ({ data = [] }) => {
      if (data) {
        return { isEditable: data.some((x) => x.url === "charts") };
      }
      return { isEditable: false };
    },
  });

  const categoryName = categoryEntity.entities[categoryId]?.name;

  const navigate = useNavigate();

  return (
    <Link to={`/charts/${url || id}`}>
      <div className="block overflow-hidden rounded-xl bg-white shadow-[0px_5px_12px_rgba(0,0,0,0.13)] md:shadow-[0px_2px_10px_rgba(0,0,0,0.1)] lg:shadow-[0px_2px_10px_rgba(0,0,0,0.1)]">
        <div
          className="relative w-full overflow-hidden bg-cover bg-center pt-[62%]"
          css={css`
            background-image: url("${thumbnailUrl}");
          `}
        >
          {categoryName && (
            <div className="absolute bottom-0 bg-grandma-300 py-1 px-2 text-[16px] leading-[18px] text-white">
              {categoryName}
            </div>
          )}
        </div>
        <article className="relative py-4 px-6">
          <h3 className="mb-2 h-[48px] overflow-hidden whitespace-pre-wrap text-[18px] font-normal leading-6">
            {name}
          </h3>

          <div className="mb-2 table w-full table-fixed">
            <p className="table-cell w-full truncate text-xs text-[#858585]">
              來源 {dataSource}
            </p>
          </div>

          <p className="flex">
            <img src={IconEye} alt="瀏覽量" className="mr-1" />
            <span className="text-[12px] leading-5">{viewsCount}</span>
          </p>
          <p style={{ position: "absolute", right: "10px", bottom: "10px" }}>
            {isEditable && (
              <img
                className="h-[34px] w-[34px]"
                src={IconEdit}
                alt="臺南城市儀表板"
                draggable="false"
                onClick={(event) => {
                  event.preventDefault();
                  navigate(`/functions/charts/${id}/edit`);
                }}
              />
            )}
          </p>
        </article>
      </div>
    </Link>
  );
};

export default Card;
